import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, DocumentExtensionHandling, FormRequiredDocumentsMapping } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-gene-therapies',
  templateUrl: './gene-therapies.component.html',
  styleUrls: ['./gene-therapies.component.scss']
})
export class GeneTherapiesComponent {
  private documentRequired: boolean = false; 
  private allowedFileTypes = [ ...DocumentExtensionHandling.MS_WORD_FILE_EXTENSIONS ];
  private acceptedFileTypes = [ ...DocumentExtensionHandling.MS_WORD_ACCEPT_TYPE ];
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {
    this.determineDocumentRequired();
  }

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { 
            fileName: DocumentConstants.GENE_THERAPIES,
            allowedFileTypes: this.allowedFileTypes,
            fileAcceptTypes: this.acceptedFileTypes
          }
        });
    dialogRef.afterClosed().subscribe();
  }

  get wasFileUploaded(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.GENE_THERAPIES);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.GENE_THERAPIES);
  }

  get isDocumentRequired(): boolean {
    return this.documentRequired;
  }
  
  get showRequiredError(): boolean {
    return this.documentRequired && this.formService.isShowingErrorSections && !this.hasDocument;
  }

  private determineDocumentRequired() {
    this.documentRequired = FormRequiredDocumentsMapping.isDocumentRequiredForForm(this.formService.getCurrentUsanFormType(), DocumentConstants.GENE_THERAPIES);
  }
  
  get hasDocument(): boolean {
      return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.GENE_THERAPIES);
  }
}
